import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const CourseList = Loadable(lazy(() => import("features/course/components/List")));
const CoursePage = Loadable(lazy(() => import("features/course/components/Page")));


const routes = {
  path: "course",
  children: [
    { path: "", element: <CourseList /> },
    { path: "add", element: <CoursePage /> },
    { path: "edit/:courseId?", element: <CoursePage /> },
  ],
};

export default routes;
